import { Navigate } from 'react-router';
import { useSelector } from 'react-redux';
import useCheckPermission from '../hooks/useCheckPermission';
import ContentPage from '../pages/contents/ContentPage';
import { userHasPlatformSaaSAccess, type AdminMode } from '../utils/adminMode';

export const Dashboard = (): JSX.Element => {
  const { checkPermission } = useCheckPermission();
  const multiTenancyEnabled = useSelector(
    (state: any) => !!state.app.featureFlags?.multiTenancyEnabled
  );
  const adminMode = useSelector(
    (state: any) => state.app.adminMode as AdminMode
  );
  const platformPermissions = useSelector(
    (state: any) => state.user.userInfo?.platformPermissions
  );
  const isSaasAdmin = userHasPlatformSaaSAccess(platformPermissions);

  if (multiTenancyEnabled && isSaasAdmin && adminMode === 'saas') {
    return <Navigate to="/platform" replace />;
  }

  return <div>{checkPermission(['ViewContent']) && <ContentPage />} </div>;
};
